// Copyright (c) 2020-2021. Sendanor <info@sendanor.fi>. All rights reserved.

import React from 'react';
import './HomeView.scss';
import FormAppClassName from "../../../constants/FormAppClassName";

export interface HomeState {

}

export interface HomeProps {
    readonly className  ?: string;
    readonly hasSession  : boolean;
}

export class HomeView extends React.Component<HomeProps, HomeState> {

    constructor(props: HomeProps) {

        super(props);

        this.state = {};

    }

    public render () {

        return (
            <div className={FormAppClassName.HOME_VIEW
                + ' ' + (this.props.className ?? '')
            }>

                <section className={FormAppClassName.HOME_VIEW+'-section ' + FormAppClassName.HOME_VIEW+'-about-section'}>

                    <h1>Sendanor's Form App</h1>

                    <p>Documentation available at <a href="https://www.sendanor.com/forms/">Sendanor.com</a>.</p>

                    <p>We track our issues at <a href="https://github.com/sendanor/ui/issues">Github</a>.</p>

                </section>

            </div>
        );

    }

}

export default HomeView;
